import React from 'react';
import Icon from '../../../components/AppIcon';

const QualityControlPanel = ({ performance }) => {
  const metrics = [
    {
      label: 'Score Qualité',
      value: performance?.qualityScore?.toFixed(1) || '0.0',
      max: '5.0',
      icon: 'Star',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100'
    },
    {
      label: 'Livraison à Temps',
      value: `${performance?.onTimeDeliveryRate || 0}%`,
      icon: 'Clock',
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      label: 'Délai Moyen',
      value: `${performance?.deliveryTimeAvg || 0}j`,
      icon: 'Calendar',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Contrôle Qualité</h2>
        <p className="text-sm text-gray-600 mt-1">Vos métriques de performance</p>
      </div>
      <div className="p-6 space-y-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className={`${metric?.bgColor} p-3 rounded-lg`}>
              <Icon name={metric?.icon} size={20} className={metric?.color} />
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-600">{metric?.label}</p>
              <p className="text-lg font-bold text-gray-900">
                {metric?.value}{metric?.max && ` / ${metric?.max}`}
              </p>
            </div>
          </div>
        ))}

        {/* Geographic Coverage */}
        {performance?.geographicCoverage?.length > 0 && (
          <div className="pt-4 border-t border-gray-200">
            <p className="text-sm font-medium text-gray-700 mb-2">Couverture Géographique</p>
            <div className="flex flex-wrap gap-2">
              {performance?.geographicCoverage?.map((country, idx) => (
                <span key={idx} className="text-xs bg-gray-100 px-2 py-1 rounded border border-gray-200">
                  {country}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Performance Notice */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} className="text-blue-600 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-blue-800">
              Vos métriques sont mises à jour automatiquement en fonction de vos performances de livraison
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityControlPanel;